import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getSettings } from "@/lib/api";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import BottomNav from "@/components/layout/BottomNav";
import SearchOverlay from "@/components/SearchOverlay";
import SaleBanner from "@/components/SaleBanner";

export default function Layout({ children }) {
  const [searchOpen, setSearchOpen] = useState(false);
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });

  return (
    <div className="min-h-screen w-full max-w-[100vw] overflow-x-hidden flex flex-col bg-[#FFFDF8]">
      <SaleBanner />
      <Header onSearchOpen={() => setSearchOpen(true)} />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      <Footer settings={settings} />
      <BottomNav settings={settings} onSearchOpen={() => setSearchOpen(true)} />
      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  );
}
